import React from 'react'
import { Route, Switch } from "react-router";
import LandingPageIndex from "./LandingPage/LandingPageIndex";
import BlogIndex from './Blog/BlogIndex'
import Terms from './Terms'

export default ({ childProps }) =>
    <Switch>
        <Route exact path='/' component={LandingPageIndex} />
        <Route path="/blog" component={BlogIndex} />
        <Route path="/blog/:id" component={BlogIndex} />
        <Route path="/terms" component={Terms} />
    </Switch>;